import { render } from "./Places.vue?vue&type=template&id=ae7e0732&scoped=true&bindings={\"places\":\"data\",\"confirmPlaceDelete\":\"data\",\"config\":\"options\",\"activeWorkspaceId\":\"options\",\"placeEditings\":\"options\",\"getPlaceEditing\":\"options\",\"getPlaces\":\"options\",\"openAddNewPlace\":\"options\",\"openEditPlace\":\"options\",\"deletePlace\":\"options\"}"
import script from "./Places.vue?vue&type=script&lang=js"
export * from "./Places.vue?vue&type=script&lang=js"

import "./Places.vue?vue&type=style&index=0&id=ae7e0732&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae7e0732"

export default script